<template class="spacer-bottom-xl">
  <div>
    <template v-for="installment in previsionInstallments" class="spacer-bottom-xl">
      <accordion :title="previsionFutureMonth(installment)" :key="installment">
        <template #accordion-badge>
          <span class="z-badge-text">{{ previsionLabel(installment) }}</span>
        </template>

        <div class="z-text spacer-bottom-s">
          <div v-if="installment == 1 && isAmountWithDiscount">
            <strong>Valor com desconto: </strong>
            <s>{{ amount | formatCurrency }}</s>
            {{ previsionAmount(installment) | formatCurrency }}
          </div>
          <div v-else>
            <strong>Valor: </strong> {{ previsionAmount(installment) | formatCurrency }}
          </div>
        </div>
      </accordion>
    </template>
  </div>
</template>

<script>
import Accordion from 'components/accordion';
import DateUtils from 'utils/date-utils';

export default {
  components: {
    Accordion,
  },
  props: {
    reenrollment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    feeType() {
      return this.reenrollment.fee_type;
    },
    firstBillDueDate() {
      return this.reenrollment.first_bill_due_date;
    },
    installments() {
      return this.reenrollment.installments;
    },
    feeAmount() {
      return this.reenrollment.due_amount;
    },
    amount() {
      return this.reenrollment.full_amount;
    },
    amountWithDiscount() {
      return this.reenrollment.installment_with_discount_amount;
    },
    year() {
      return DateUtils.getYear(this.firstBillDueDate);
    },
    hasFee() {
      return this.feeType === 'reenrollment_fee';
    },
    isAmountWithDiscount() {
      return this.feeType === 'first_bill_with_discount';
    },
    isAmountWithoutDiscount() {
      return this.feeType === 'first_bill_without_discount';
    },
    previsionInstallments() {
      if (this.hasFee) {
        return this.installments + 1;
      }
      return this.installments;
    },
  },
  methods: {
    monthName(date) {
      return DateUtils.getMonthName(date);
    },
    previsionFutureMonth(installment) {
      const baseInstallment = (installment > 1 && this.hasFee) ? installment - 1 : installment;
      const previsionFutureDate = DateUtils.parseDate(this.firstBillDueDate).add(baseInstallment - 1, 'M');
      return this.monthName(previsionFutureDate);
    },
    previsionLabel(installment) {
      if (installment === 1 && this.hasFee) {
        return 'taxa de rematrícula';
      }
      return 'mensalidade';
    },
    previsionAmount(installment) {
      if (installment === 1 && this.hasFee) {
        return this.feeAmount;
      } if (installment === 1 && this.isAmountWithoutDiscount) {
        return this.amount;
      }

      return this.amountWithDiscount;
    },
  },
};
</script>
